import {
  DataStoreModel,
  ModelTypes,
} from '../../dataStorePersistence/DataStoreModel';

export enum LinkType {
  conneqt = 'CONNEQT',
  player = 'PLAYER',
  incident = 'INCIDENT',
  assessment = 'ASSESSMENT',
  cleared = 'CLEARED',
  roleUpdate = 'ROLE_UPDATE',
  none = 'NONE', // read only notification. No action required.
}

// export interface Assessment extends DataStoreModel<ModelTypes.Assessment> {
export interface Notification extends DataStoreModel {
  readonly modelType: ModelTypes.Notification;
  readonly accountId: string;
  readonly createdByUserId: string;
  readonly mainText: string;
  readonly createdAt: string;
  readonly linkType: LinkType;
  readonly linkId: string;
  readonly read: boolean;
}

export interface NotificationBackend extends DataStoreModel {
  readonly modelType: ModelTypes.Notification;
  readonly accountId: string;
  readonly createdByUserId: string;
  readonly mainText: string;
  readonly notificationTime: string;
  readonly linkType: LinkType;
  readonly linkId: string;
  readonly read: boolean;
}
